import React, { useEffect, useState } from 'react';
import { StatusBadge } from '../../components/admin/StatusBadge';

export const ChangeRequestList: React.FC = () => {
  const [requests, setRequests] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    fetch('/api/admin/change-requests', { credentials: 'include' })
      .then(r => r.json())
      .then(data => { setRequests(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(load, []);

  const handleResolve = async (id: string) => {
    const res = await fetch('/api/admin/change-requests', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ id, status: 'resolved' }),
    });
    if (res.ok) {
      setRequests(prev => prev.map(r => r.id === id ? { ...r, status: 'resolved', resolvedAt: new Date().toISOString() } : r));
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-[#1A1A1A] tracking-tight">Change Requests</h1>
          <p className="text-sm text-[#A3A3A3] mt-1">Submitted by buyers from their portal</p>
        </div>
      </div>

      {loading ? (
        <div className="space-y-3">{[...Array(3)].map((_, i) => <div key={i} className="h-20 bg-white rounded-2xl animate-pulse shadow-sm" />)}</div>
      ) : (
        <div className="space-y-3">
          {requests.map(req => (
            <div key={req.id} className="bg-white border border-[#E8E6E2]/60 rounded-2xl p-5 shadow-sm shadow-black/[0.03]">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1.5">
                    <p className="font-semibold text-[#1A1A1A] text-sm">{req.buyerName || 'Unknown buyer'}</p>
                    <span className="text-[#C4C4C4]">&middot;</span>
                    <p className="text-sm text-[#6B6B6B]">{req.contractNumber || 'Unknown contract'}</p>
                  </div>
                  <p className="text-sm text-[#1A1A1A] whitespace-pre-wrap">{req.message}</p>
                  <p className="text-xs text-[#A3A3A3] mt-2">{new Date(req.createdAt).toLocaleString()}</p>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <StatusBadge status={req.status} />
                  {req.status === 'open' && (
                    <button onClick={() => handleResolve(req.id)} className="px-3 py-1.5 text-[12px] font-medium text-emerald-600 hover:text-emerald-800 hover:bg-emerald-50 rounded-lg transition-colors">
                      Mark Resolved
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
          {requests.length === 0 && (
            <div className="bg-white border border-[#E8E6E2]/60 rounded-2xl p-12 text-center shadow-sm shadow-black/[0.03]">
              <p className="text-[#A3A3A3]">No change requests yet.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
